<template>
	<Transition
		enterActiveClass="transition-all duration-500"
		leaveActiveClass="transition-all duration-500"
		enterFromClass="h-0!"
		leaveToClass="h-0!"
	>
		<div class="h-10.75" v-if="show">
			<div class="flex items-center gap-2 px-3 pt-2 pb-3">
				<WreathIcon class="mr-auto h-5 w-5 text-white opacity-10" />
				<div class="text-label-tertiary text-sm font-medium uppercase">
					{{ t('jackpot') }}
				</div>
				<div class="text-label-tertiary text-sm font-medium">-</div>
				<CoinPrice
					:price="currentJackpot"
					mono
					:minDigits="2"
					:animationDuration="1000"
				/>
				<WreathIcon
					class="ml-auto h-5 w-5 -scale-x-100 text-white opacity-10"
				/>
			</div>
			<div class="relative flex h-0.75 w-full px-3">
				<div
					v-for="segment in segments"
					class="border-l-fill-tertiary border-r-fill-tertiary h-full border-r border-l transition-all duration-500"
					:class="[segment.color]"
					:style="{ width: segment.chance }"
				></div>
				<div
					class="from-fill-tertiary absolute top-0 bottom-0 left-3 w-12 bg-linear-to-r to-transparent"
				/>
				<div
					class="from-fill-tertiary absolute top-0 right-3 bottom-0 w-12 bg-linear-to-l to-transparent"
				/>
			</div>
		</div>
	</Transition>
</template>
<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import CoinPrice from './CoinPrice.vue'
import WreathIcon from '@/assets/icons/wreath.svg'
import { computed, ref, watch } from 'vue'
import { chance } from '@/utils/chance'

const colors = [
	'bg-[#E01533]', // red
	'bg-[#E4A211]', // yellow
	'bg-[#E06315]', // orange
	'bg-[#84B611]' // green
]

const { t } = useI18n({
	messages: {
		en: {
			jackpot: 'Jackpot'
		},
		ru: {
			jackpot: 'Jackpot'
		}
	}
})

const props = defineProps<{
	show?: boolean
	participants: {
		teamIndex: number
	}[]
	rounds: {
		results: {
			participant: {
				teamIndex: number
			}
			item?: {
				price: number
			}
		}[]
	}[]
	currentRound: number
	isCrazy?: boolean
}>()

const currentJackpot = computed(() => {
	if (!props.currentRound) {
		return 0
	}

	return props.rounds.slice(0, props.currentRound).reduce((acc, round) => {
		return (
			acc +
			round.results.reduce((acc, result) => {
				if (result.item) {
					return acc + result.item.price
				}
				return acc
			}, 0)
		)
	}, 0)
})

const segments = computed(() => {
	if (!props.currentRound) {
		const teams = props.participants.reduce((acc, participant) => {
			if (!acc.includes(participant.teamIndex)) {
				acc.push(participant.teamIndex)
			}
			return acc
		}, [] as number[])

		return teams.map((teamIndex) => ({
			color: colors[teamIndex],
			chance: `${Math.floor((1 / teams.length) * 10000) / 100}%`
		}))
	}

	const teamTickets: { teamIndex: number; tickets: number; color: string }[] =
		[]

	props.rounds.slice(0, props.currentRound).forEach((round) => {
		round.results.forEach((result) => {
			if (!result.item) {
				return
			}

			const teamColor = colors[result.participant.teamIndex]
			const team = teamTickets.find(
				(t) => t.teamIndex === result.participant.teamIndex
			)

			if (!teamColor) {
				return
			}

			if (!team) {
				teamTickets.push({
					teamIndex: result.participant.teamIndex,
					tickets: result.item.price,
					color: teamColor
				})
			} else {
				team.tickets += result.item.price
			}
		})
	})

	// const teamColor = colors[result.participant.teamIndex]

	return teamTickets.map((r) => ({
		color: r.color,
		chance: `${chance(r.teamIndex, teamTickets, props.isCrazy) * 100}%`
	}))
})
</script>
